<template>
<div class="">
  <div class="box-content--header container align-items-center justify-content-center hidden">
    <div class="box-content--header__img">
      <div class="img1 container align-items-center justify-content-center animation-bottom">
        <div class="img2 container align-items-center justify-content-center">
          <img src="@/assets/img/icon-words.svg" width="50" alt="Minds">
        </div>
      </div>
    </div>
    <div class="box-content--header__text flex-grow-1 flex-basis-400">
      <h2 class="animation-top animation-delay-02"><span>VOUCHERS</span></h2>
      <hr class="header-text-hr animation-top animation-delay-02">
      <p class="animation-bottom animation-delay-04">Voucher wallet.</p>
    </div>
  </div>
  <div class="box-content shadow-box box-content-border hidden">
    <div class="box--item animation-bottom animation-delay-05 list flex-grow-1 container column">

      <div class="list__content container">

        <div
          class="list__content__item flex-grow-1 flex-basis-200 container justify-content-center align-center"
          v-for="(voucher, index) in vouchers"
          :key="index"
        >

          <!-- <div style="background: rgb(220, 62, 16); border-radius: 20px;"> -->
          <div style="background: linear-gradient(to bottom, #DC3E10, #DC3E10, #DC3E10, #FFC9B8, #FFC9B8, #FFC9B8); border-radius: 20px;">
            <div class="list__content__item__name" v-if="!!voucher">
              <p>{{ voucher.product }}</p>
            </div>

            <div class="list__content__item__description flex-grow-1" v-if="!!voucher">
              <p>{{ voucher.description }}</p>
            </div>

            <div class="list__content__item__voucher margin-bottom-10 full-width align-center">
              <b>{{ voucher.voucher }}</b>
            </div>

            <div class="list__content__item__valid full-width align-center" :class="{ invalid: !voucher.valid }">
              {{ voucher.valid ? 'AVAILABLE' : 'USED' }}
            </div>
          </div>


        </div>

      </div>

      <div class="list__paging container align-center" v-if="_vouchers_.length > 3">
        <div class="list__paging__pages">
          <span @click="prevPage()" :disabled="!allowBack">
            <font-awesome-icon icon="caret-left"/>
          </span>
          <span
            v-for="p in Math.ceil(parseInt(_vouchers_.length) / 3)"
            :class="{ current: (p - 1) == page }"
            @click="page = (p - 1)"
          >
            {{ p }}
          </span>
          <span @click="nextPage()" :disabled="!allowNext">
            <font-awesome-icon icon="caret-right"/>
          </span>
        </div>
      </div>

    </div>

  </div>
</div>
</template>

<script type="text/javascript">
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      page: 0
    }
  },
  computed: {
    ...mapGetters({
      _vouchers_: 'voucher/getAll'
    }),
    vouchers () {
      return this._vouchers_
              .sort((a, b) => b.date - a.date)
              .map(v => {
                const date = new Date(v.date)
                date.setHours(date.getHours() - 3)
                return {
                  ...v,
                  date: this.$toDate(date)
                }
              })
              .slice(this.page * 3, 3 * (this.page + 1))
    },
    allowBack () {
      return this.page > 0
    },
    allowNext () {
      return this.page < Math.trunc(this._vouchers_.length / 4)
    }
  },
  methods: {
    nextPage () {
      if (this.allowNext) this.page++
    },
    prevPage () {
      if (this.allowBack) this.page--
    }
  }
}
</script>

<style lang="scss" scoped>
  /*        NOVO CARD         */
  .list {
    padding: 0;
    min-height: 300px;
    &__content {
      flex-wrap: wrap;
      &__item {
        margin: 15px;
        // padding: 10px;
        border-radius: 10px;
        // background-color: #E8E8E8;
        transition: all .2s;
        flex-direction: column;
        max-width: 220px;
        cursor: pointer;
        &:hover {
          // background-color: rgb(104, 34, 34);
          filter: brightness(.8);
          transform: scale(1.1)
        }
        &.disabled {
          cursor: not-allowed;
          // background-color: #E4E4E4;
          // color: #888;
          filter: grayscale(1);
        }
        &__name{
          background: #FF7E56;
          color: white;
          height: 150px;
          display: flex;
          width: 100%;
          align-items: center;
          justify-content: center;
          border-radius: 10px;
          box-shadow: inset 2px -110px 67px -77px #d63300;
          p { font-size: 40px; }
        }
        &__description {
          text-align: left;
          padding: 20px;
          background: #FFC9B8;
          font-weight: 200;
          color: #d63300;
          border-radius: 40px 0px 0px 0px;
          line-height: 20px;
        }
        &__valid {
          text-align: left;
          padding: 20px;
          background: #F36B41;
          font-weight: 200;
          margin: 10px auto;
          width: 200px;
          color: #FFC9B8;
          border-radius: 300px;
          line-height: 20px;
          img  {
            width: 25px;
            margin-right: 10px;
          }
          span {
            font-size: 28px;
            background: #FF7E56;
            padding: 15px 25px;
            border-radius: 300px;
          }
          p {
            background: #FFC9B8;
            padding: 15px;
          }
        }
        &__voucher {
          text-align: left;
          padding: 20px;
          margin: 10px auto;
          width: 200px;
          background: #F36B41;
          font-weight: 200;
          color: #FFC9B8;
          border-radius: 300px;
          line-height: 20px;
        }
      }
    }
    &__paging {
      &__pages {
        text-align: center;
        display: flex;
        span {
          cursor: pointer;
          display: flex;
          border-radius: 25px;
          background-color: #DDD;
          margin: 5px 5px;
          width: 34px;
          height: 34px;
          justify-content: center;
          align-items: center;
          &.current {
            background-color: #BBB;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/vouchers/index.vue